import React from 'react';
import { Link } from 'react-router-dom';
import { UserRound, Building2 } from 'lucide-react';

export const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const COMPANY = {
  edp: 'EDP', galp: 'Galp', endesa: 'Endesa', iberdrola: 'Iberdrola', gold: 'Gold Energy',
  repsol: 'Repsol', yes: 'Yes', meo_energia: 'Meo Energia', nos: 'NOS', meo: 'MEO',
  vodafone: 'Vodafone', nos_securitas: 'NOS Securitas', prosegur: 'Prosegur',
  primeira_contratacao: 'Primeira contratação', outra: 'Outra', renovacao: 'Renovação',
};
export const companyLabel = (c) => (c ? COMPANY[c] || c.toUpperCase() : '—');

export const GRUPO = {
  energia: { label: 'Energia', cls: 'bg-amber-50 text-amber-800 border-amber-200' },
  telecomunicacoes: { label: 'Telecomunicações', cls: 'bg-sky-50 text-sky-800 border-sky-200' },
  alarmes: { label: 'Alarmes', cls: 'bg-violet-50 text-violet-800 border-violet-200' },
};

export const ESTADO = {
  hora_de_mudar: { label: 'Hora de mudar', cls: 'bg-rose-600 text-white' },
  fidelizado: { label: 'Fidelizado', cls: 'bg-emerald-100 text-emerald-800' },
  sem_fidelizacao: { label: 'Sem fidelização', cls: 'bg-slate-100 text-slate-700' },
  em_curso: { label: 'Em processamento', cls: 'bg-sky-100 text-sky-800' },
  substituido: { label: 'Já mudou', cls: 'bg-slate-200 text-slate-600' },
  inativo: { label: 'Anulado / Baixa', cls: 'bg-slate-100 text-slate-400 line-through' },
};

export const LEAD_STATUS = {
  nova: 'Nova', em_contacto: 'Em Contacto', reagendada: 'Reagendada', proposta: 'Proposta',
  convertida: 'Convertida', sem_interesse: 'Sem Interesse', invalida: 'Inválida',
};

export const fmtDate = (iso) => {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleDateString('pt-PT'); } catch { return iso; }
};
export const fmtDT = (iso) => {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleString('pt-PT', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' }); } catch { return iso; }
};

export const clientUrl = (nif, name, { contractId, leadId } = {}) => {
  if (nif && !String(nif).includes('*')) return `/clientes/360?nif=${encodeURIComponent(nif)}`;
  if (contractId) return `/clientes/360?contract_id=${encodeURIComponent(contractId)}`;
  if (leadId) return `/clientes/360?lead_id=${encodeURIComponent(leadId)}`;
  return `/clientes/360?name=${encodeURIComponent(name || '')}`;
};

export const ClientLink = ({ nif, name, testId, contractId, leadId }) => {
  if (!nif && !name) return null;
  return (
    <Link
      to={clientUrl(nif, name, { contractId, leadId })}
      title="Abrir Página do Cliente"
      onClick={(e) => e.stopPropagation()}
      data-testid={testId || 'client-360-link'}
      className="inline-flex items-center justify-center w-6 h-6 rounded-full text-[#2D3E6F] hover:bg-[#4DD4E8]/20 transition-colors shrink-0"
    >
      <UserRound className="w-3.5 h-3.5" />
    </Link>
  );
};

export const empresaUrl = (c) => `/empresas/360/${encodeURIComponent((c || '').toLowerCase())}`;

export const EmpresaLink = ({ company, testId, className = '' }) => {
  if (!company) return null;
  return (
    <Link to={empresaUrl(company)} onClick={(e) => e.stopPropagation()} title="Abrir Página da Empresa" data-testid={testId || `empresa-link-${company}`}
      className={`inline-flex items-center gap-1 hover:text-[#4DD4E8] hover:underline ${className}`}>
      {companyLabel(company)}<Building2 className="w-3 h-3 opacity-60" />
    </Link>
  );
};

export const ClientPageButton = ({ nif, name, testId, contractId, leadId }) => {
  if (!nif && !name) return null;
  return (
    <Link
      to={clientUrl(nif, name, { contractId, leadId })}
      data-testid={testId || 'client-360-button'}
      className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-[#2D3E6F] text-white hover:bg-[#4DD4E8] hover:text-[#2D3E6F] transition-colors"
    >
      <UserRound className="w-3.5 h-3.5" /> Ver cliente
    </Link>
  );
};
